import React from 'react';

const IconFailed = () => {
  return (
    <svg
      width="141"
      height="60"
      viewBox="0 0 141 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_544_191465)">
        <path
          d="M16.3037 49.7073C15.9663 49.7073 15.6211 49.6306 15.2913 49.4695C15.0152 49.3315 8.38861 46.0565 3.77913 41.9149C0.933673 39.3532 -0.201441 35.6641 0.833967 32.2741C1.74666 29.2676 4.26232 27.1124 7.39922 26.6599C10.4134 26.2304 12.3769 27.4728 13.8111 28.3779C15.4371 29.4056 15.7745 29.6204 17.6153 28.1401C18.6046 27.3425 20.0542 27.4959 20.8519 28.4929C21.6495 29.4823 21.4884 30.9319 20.4991 31.7295C16.0967 35.2729 13.2359 33.4629 11.3414 32.2664C10.0836 31.4688 9.31665 31.0316 8.05115 31.2157C6.66293 31.4151 5.63519 32.2894 5.23637 33.6086C4.84522 34.9124 5.05997 36.8759 6.86235 38.4942C10.9886 42.2063 17.2624 45.3125 17.3238 45.3432C18.4666 45.9031 18.9344 47.2837 18.3746 48.4264C17.9757 49.2394 17.1551 49.715 16.3037 49.715V49.7073Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M113.61 38.9774C113.135 38.7473 112.728 38.3562 112.498 37.8346C109.89 31.906 113.311 27.1891 115.489 25.5171C116.494 24.7425 117.944 24.9342 118.718 25.9389C119.485 26.9437 119.301 28.3779 118.304 29.1525C117.944 29.444 114.96 31.9903 116.716 35.9709C117.23 37.1367 116.701 38.4942 115.535 39.0081C114.899 39.2919 114.193 39.2535 113.61 38.9774Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.2873 29.5287C30.6236 26.944 31.6744 22.4956 30.1021 18.7758L30.3398 18.5917L28.9056 16.7433L25.5003 17.1498L26.2672 15.6082L24.8407 13.7598C21.9952 12.7167 18.6896 13.1232 16.1202 15.1173C12.1397 18.2005 11.4187 23.9221 14.5019 27.9027L15.9362 29.7511L16.1739 29.567C19.3799 32.0137 23.951 32.1134 27.2873 29.5287Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5554 16.9655C20.1247 14.9714 23.4227 14.5725 26.2682 15.6079L25.5012 17.1496C25.5012 17.1496 29.6428 17.6864 30.3408 18.5915C33.424 22.572 32.6954 28.2936 28.7225 31.3768C24.7419 34.4601 19.0203 33.7314 15.9371 29.7585C12.8539 25.778 13.5825 20.0564 17.5554 16.9732V16.9655Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.1367 30.4647C26.6143 30.4647 29.4335 27.6455 29.4335 24.1679C29.4335 20.6903 26.6143 17.8711 23.1367 17.8711C19.659 17.8711 16.8398 20.6903 16.8398 24.1679C16.8398 27.6455 19.659 30.4647 23.1367 30.4647Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.2741 15.6162L23.3903 21.3761L25.4074 23.0865L22.5312 26.3078L27.8847 23.0021L25.6221 19.29L30.0015 18.1472L28.9124 16.7437L25.4227 17.4186L26.2741 15.6162Z"
          fill="var(--neutral_12)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M114.539 23.0477C113.228 18.7144 115.068 14.1739 118.75 11.896L118.658 11.5815L121.058 10.8529L123.781 13.3226L124.065 11.4972L126.458 10.7686C129.595 11.6276 132.233 14.0282 133.245 17.3645C134.81 22.5262 131.896 27.987 126.726 29.5516L124.326 30.2802L124.234 29.9658C119.908 30.1192 115.851 27.3658 114.539 23.0324V23.0477Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.835 18.1086C129.823 14.7723 127.185 12.3717 124.055 11.5127L123.772 13.3381C123.772 13.3381 119.822 11.2366 118.648 11.5894C113.487 13.154 110.564 18.6148 112.129 23.7765C113.694 28.9382 119.154 31.8604 124.316 30.2958C129.478 28.7312 132.4 23.2703 130.835 18.1086Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M121.487 27.6956C125.219 27.6956 128.244 24.6704 128.244 20.9386C128.244 17.2069 125.219 14.1816 121.487 14.1816C117.756 14.1816 114.73 17.2069 114.73 20.9386C114.73 24.6704 117.756 27.6956 121.487 27.6956Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M124.056 11.5123L122.998 18.3383L120.183 18.5837L120.689 23.1855L118.059 16.9731L122.346 15.1324L119.224 11.4202L121.05 10.8604L123.68 13.6138L124.056 11.5123Z"
          fill="var(--neutral_12)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.832 29.9428C43.832 16.237 53.1584 4.71716 65.8057 1.36551V0.383789H73.391C89.7121 0.383789 102.95 13.614 102.95 29.9428C102.95 46.2639 89.7198 59.5018 73.391 59.5018H65.8057V58.5201C53.1584 55.1684 43.832 43.6485 43.832 29.9428Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.832 29.9428C43.832 16.237 53.1584 4.71716 65.8057 1.36551V0.383789H73.391C89.7121 0.383789 102.95 13.614 102.95 29.9428C102.95 46.2639 89.7198 59.5018 73.391 59.5018H65.8057V58.5201C53.1584 55.1684 43.832 43.6485 43.832 29.9428Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M65.8051 59.5018C82.1301 59.5018 95.3641 46.2678 95.3641 29.9428C95.3641 13.6178 82.1301 0.383789 65.8051 0.383789C49.4801 0.383789 36.2461 13.6178 36.2461 29.9428C36.2461 46.2678 49.4801 59.5018 65.8051 59.5018Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M65.804 55.153C79.7273 55.153 91.0143 43.866 91.0143 29.9427C91.0143 16.0194 79.7273 4.73242 65.804 4.73242C51.8808 4.73242 40.5938 16.0194 40.5938 29.9427C40.5938 43.866 51.8808 55.153 65.804 55.153Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M93.6633 8.34473H86.0703"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M101.771 21.8818H94.4922"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M102.491 35.4268H94.8984"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M96.0578 48.9707H88.4648"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M-3.55078 59.54L140.824 59.54"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M80.9428 21.7669L74.8761 15.7002H71.1563L67.3215 23.2548L59.7745 15.7002H56.0547L61.2547 29.3216L56.0547 42.9353H59.7745L67.3215 35.3883L71.1563 42.9353H74.8761L80.9428 36.8685L73.3882 29.3216L80.9428 21.7669Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M77.2234 21.7669L71.1566 15.7002L63.602 23.2548L56.055 15.7002L49.9883 21.7669L57.5353 29.3216L49.9883 36.8685L56.055 42.9353L63.602 35.3883L71.1566 42.9353L77.2234 36.8685L69.6687 29.3216L77.2234 21.7669Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.1465 59.5395C38.0238 54.4698 36.5359 52.7978 34.9559 51.0261C33.5524 49.4462 31.9571 47.6591 31.9571 44.1311C31.9571 39.5063 35.4621 37.8803 37.786 36.8065C40.0409 35.7558 40.4704 35.3953 40.4704 34.521C40.4704 33.4549 40.156 33.1404 40.0332 33.0177C38.9441 31.9363 35.3164 31.9516 31.796 31.9593H30.5535C29.38 31.9593 28.5517 32.2584 28.0072 32.872C26.9564 34.0531 26.9641 36.2773 27.0561 37.0366C27.2095 38.2944 26.3198 39.4449 25.062 39.5983C23.7965 39.7517 22.6614 38.8773 22.4927 37.6195C22.4313 37.1363 21.9481 32.8029 24.5405 29.8424C25.5375 28.7073 27.3859 27.3575 30.5535 27.3575H31.7883C36.6509 27.3498 40.8462 27.3268 43.2852 29.7581C44.474 30.9392 45.0722 32.5422 45.0722 34.521C45.0722 38.5015 41.8586 39.9894 39.7265 40.9788C37.3795 42.0679 36.5589 42.5818 36.5589 44.1311C36.5589 45.9028 37.2108 46.6391 38.3919 47.9659C40.156 49.9524 42.5719 52.6674 42.7406 59.4244L38.1388 59.5395H38.1465Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.1546 44.9212C31.3493 39.2226 26.7935 34.9813 21.3403 34.3293L21.279 33.9229L18.1267 34.3677L16.309 38.6781L15.0052 36.73L11.8606 37.1671C8.70836 39.8285 6.952 44.0085 7.57325 48.3956C8.53196 55.1832 14.8134 59.9078 21.6011 58.9491L24.7534 58.5042L24.692 58.0977C29.754 55.9655 32.9599 50.6198 32.1546 44.9212Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7256 47.9511C10.1043 43.564 11.8607 39.3917 15.0129 36.7227L16.3168 38.6708C16.3168 38.6708 19.7451 34.138 21.2868 33.9156C28.0744 32.9568 34.3559 37.6814 35.3146 44.469C36.2733 51.2567 31.5488 57.5382 24.7611 58.4969C17.9734 59.4556 11.692 54.7311 10.7333 47.9434L10.7256 47.9511Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.0199 54.8005C27.7598 54.8005 31.6023 50.958 31.6023 46.2181C31.6023 41.4782 27.7598 37.6357 23.0199 37.6357C18.28 37.6357 14.4375 41.4782 14.4375 46.2181C14.4375 50.958 18.28 54.8005 23.0199 54.8005Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0117 36.7223L19.882 44.0239L23.2643 42.7967L25.1357 48.3803L24.8443 39.8056L18.9233 39.982L20.5339 34.0303L18.1256 34.3677L16.5687 38.9465L15.0117 36.7223Z"
          fill="var(--neutral_12)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.7486 59.4323C42.6259 52.7443 44.0371 50.4051 46.4684 50.2824C48.8997 50.1597 48.8307 53.1508 51.5611 53.3963C54.2915 53.6417 54.6136 52.5143 57.0833 54.1096C59.5529 55.7048 60.4273 58.6653 63.6639 56.05C66.9005 53.4346 64.0473 46.8617 60.3812 46.2481C56.7151 45.6345 55.9482 47.6363 53.7316 45.8416C51.5151 44.0469 41.3144 42.7584 39.5273 52.3915"
          fill="var(--main_0)"
        />
        <path
          d="M42.7486 59.4323C42.6259 52.7443 44.0371 50.4051 46.4684 50.2824C48.8997 50.1597 48.8307 53.1508 51.5611 53.3963C54.2915 53.6417 54.6136 52.5143 57.0833 54.1096C59.5529 55.7048 60.4273 58.6653 63.6639 56.05C66.9005 53.4346 64.0473 46.8617 60.3812 46.2481C56.7151 45.6345 55.9482 47.6363 53.7316 45.8416C51.5151 44.0469 41.3144 42.7584 39.5273 52.3915"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.4187 59.4939C33.4133 59.4939 33.2983 57.3771 28.7425 57.7759C24.1867 58.1747 27.569 59.6013 16.8468 59.6013C6.12455 59.6013 3.83131 54.6083 6.13222 52.0006C8.43313 49.4006 12.4367 52.8213 17.0922 52.7062C21.7477 52.5912 27.1625 48.5109 32.0558 49.0171C36.949 49.5233 36.3585 53.8874 38.0458 55.1452"
          fill="var(--main_0)"
        />
        <path
          d="M39.4187 59.4939C33.4133 59.4939 33.2983 57.3771 28.7425 57.7759C24.1867 58.1747 27.569 59.6013 16.8468 59.6013C6.12455 59.6013 3.83131 54.6083 6.13222 52.0006C8.43313 49.4006 12.4367 52.8213 17.0922 52.7062C21.7477 52.5912 27.1625 48.5109 32.0558 49.0171C36.949 49.5233 36.3585 53.8874 38.0458 55.1452"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M106.07 59.5172V52.3614C106.07 51.395 104.437 50.6587 101.944 49.6387C98.2857 48.1508 93.2773 46.1029 93.2773 40.1819C93.2773 35.8639 96.1765 32.3052 100.656 31.1087C105.196 29.8969 111.646 31.3158 115.075 37.2828C115.704 38.3872 115.328 39.7908 114.223 40.4274C113.119 41.064 111.715 40.6805 111.079 39.576C108.847 35.6875 104.836 34.7595 101.837 35.5571C100.909 35.8026 97.8792 36.8686 97.8792 40.1819C97.8792 42.736 99.7352 43.7714 103.677 45.3743C106.791 46.6475 110.672 48.2275 110.672 52.3614V59.5402L106.07 59.5172Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M117.013 37.2363C122.075 35.6027 127.436 37.6735 130.175 41.9455L130.535 41.8305L131.44 44.6299L128.595 47.8742L130.734 48.1656L131.639 50.9574C130.696 54.6542 127.935 57.7988 124.039 59.0489C118.01 60.9894 111.552 57.6837 109.612 51.6554L108.707 48.8559L109.068 48.7409C108.799 43.6712 111.944 38.8623 116.998 37.2287L117.013 37.2363Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M123.142 56.2644C127.038 55.0065 129.799 51.8696 130.735 48.1729L128.595 47.8814C128.595 47.8814 130.98 43.2029 130.535 41.8377C128.595 35.8093 122.129 32.5037 116.108 34.4441C110.088 36.3845 106.774 42.8501 108.715 48.8708C110.655 54.8992 117.121 58.2048 123.142 56.2644Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M119.63 53.2733C124.005 53.2733 127.553 49.7262 127.553 45.3505C127.553 40.9749 124.005 37.4277 119.63 37.4277C115.254 37.4277 111.707 40.9749 111.707 45.3505C111.707 49.7262 115.254 53.2733 119.63 53.2733Z"
          fill="var(--main_0)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M130.736 48.1728L122.713 47.0684L122.368 43.7704L116.977 44.4607L124.209 41.2471L126.456 46.24L130.751 42.4972L131.442 44.6294L128.266 47.774L130.736 48.1728Z"
          fill="var(--neutral_12)"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M110.388 59.4093C110.388 59.4093 110.657 57.7987 112.513 57.6069C114.369 57.4152 113.05 59.4553 119.024 59.5014C124.999 59.5474 126.119 59.1716 128.757 57.5072C131.395 55.8429 132.416 53.519 130.092 52.0234C127.768 50.5278 123.787 51.8393 119.983 52.568C116.179 53.2966 115.373 50.7349 112.06 50.5355C108.747 50.3437 109.376 53.6034 109.376 53.6034"
          fill="var(--main_0)"
        />
        <path
          d="M110.388 59.4093C110.388 59.4093 110.657 57.7987 112.513 57.6069C114.369 57.4152 113.05 59.4553 119.024 59.5014C124.999 59.5474 126.119 59.1716 128.757 57.5072C131.395 55.8429 132.416 53.519 130.092 52.0234C127.768 50.5278 123.787 51.8393 119.983 52.568C116.179 53.2966 115.373 50.7349 112.06 50.5355C108.747 50.3437 109.376 53.6034 109.376 53.6034"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M107.649 55.2375C107.649 55.2375 104.627 55.2606 102.909 50.7431C101.191 46.2257 96.8804 44.9295 93.7052 46.9773C90.5299 49.0251 90.1081 51.9166 86.0508 51.372C81.9936 50.8275 78.6879 52.7142 80.8201 55.4293C82.9523 58.152 87.6001 58.4818 90.0237 57.9373C92.4474 57.3927 93.5364 55.2989 96.7577 56.0505C99.979 56.8022 101.82 59.5249 106.468 59.5249"
          fill="var(--main_0)"
        />
        <path
          d="M107.649 55.2375C107.649 55.2375 104.627 55.2606 102.909 50.7431C101.191 46.2257 96.8804 44.9295 93.7052 46.9773C90.5299 49.0251 90.1081 51.9166 86.0508 51.372C81.9936 50.8275 78.6879 52.7142 80.8201 55.4293C82.9523 58.152 87.6001 58.4818 90.0237 57.9373C92.4474 57.3927 93.5364 55.2989 96.7577 56.0505C99.979 56.8022 101.82 59.5249 106.468 59.5249"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.09766 14.0967L5.31126 17.3026"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.09766 17.3026L5.31126 14.0967"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M136.586 23.7607L139.792 26.9743"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M136.586 26.9743L139.792 23.7607"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M101.551 3.44336L109.458 11.3508"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M101.551 11.3508L109.458 3.44336"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6953 3.44336L18.3296 10.0776"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6953 10.0776L18.3296 3.44336"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M80.3203 53.0437C80.3203 53.0437 84.0938 54.8614 88.2048 54.616C92.3157 54.3629 92.3541 51.2567 96.8485 51.5098C101.335 51.7629 100.246 56.5948 107.647 59.2945"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.64844 52.5068C5.64844 52.5068 8.61661 55.7358 15.8568 55.8355C23.097 55.9352 24.4545 52.8673 29.4398 53.1434C34.4251 53.4195 34.0186 57.101 39.0116 59.4326"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M62.7416 56.6868C62.7416 56.6868 63.8461 54.0101 59.9499 50.9346C56.0537 47.859 55.2714 50.2136 50.5545 48.3806C45.8376 46.5475 40.814 49.5234 41.0594 56.8786"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M109.32 59.5013C109.32 59.5013 110.21 53.7183 114.597 54.2859C118.984 54.8534 117.742 56.6635 122.604 56.3183C127.467 55.9732 131.57 54.2245 130.581 52.3838"
          stroke="var(--neutral_12)"
          strokeWidth="0.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_544_191465">
          <rect width="140.102" height="60" fill="var(--main_0)" transform="translate(0.0742188)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconFailed;
